function init_custom_file_uploader(elm) {
    var $ = jQuery.noConflict();
    elm = $(elm);
    elm.customFileUploader();
}

(function ($) {
    $.fn.customFileUploader = function (params) {
        $(this).each(function () {
            var elm = $(this);

            if (elm.hasClass('has-custom-file-uploader')) {
                return;
            }
            elm.addClass('has-custom-file-uploader');
            var id = get_unique_id();
            var name = elm.attr('data-name') == undefined ? 'filename' : elm.attr('data-name');

            var upload_input;
            if (elm.is('[data-fill-only]')) {
                if (elm.next().attr('type') != 'file') {
                    alert('CustomFileUploader needs the next item to be an input[type=file] when [data-fill-only] is on.');
                    return;
                }
                upload_input = elm.next();
                upload_input.attr('data-fill-only', 1);
                //upload_input.css('visibility','visible');
                upload_input.hide();
            } else {
                elm.after('<input type="hidden" name="' + name + '" />');
                $('body').append('<input type="file" name="' + name + '" id="' + id + '" style="visibility: none;" />');
                upload_input = $('input#' + id);
            }

            if (elm.is('[data-accept]')) {
                upload_input.attr('accept', elm.attr('data-accept'));
            }

            upload_input[0].attached_elm = elm;

            if (elm[0].onload) {
                elm[0].onload(upload_input);
            }

            elm.unbind('click').click(function () {

                if ($(this).is('[data-fill-only]')) {
                    upload_input = $(this).next();
                }

                upload_input.click();
            });

            make_item_drag_and_droppable(elm, upload_input);

            upload_input.change(function () {

                var input = $(this);
                var elm = input[0].attached_elm;
                if (input.is('[data-fill-only]')) {
                    elm = input.prev();
                }
                var fReader = new FileReader();
                var file = input[0].files[0];
                elm.attr('data-ori-filename', file.name);

                let fieldset = input.parents('fieldset');


                if (fieldset.length > 0 && fieldset.find('[data-file-name-wrapper]').length > 0) {
                    let fileNameWrapper = fieldset.find('[data-file-name-wrapper]');
                    let name = file.name.split('.');
                    name.pop();
                    name = name.join('.');
                    fileNameWrapper.val(name);
                }

                if (elm.is('[data-fill-only]') || input.is('[data-fill-only]')) {
                    return;
                }

                fReader.readAsDataURL(file);
                fReader.onloadend = function (event) {

                    if (file.type.split('/')[0] == "image" && !elm.is('[data-no-background-image]')) {
                        elm.css({'background-image': 'url(' + event.target.result + ')'}).attr('data-current-image', 'set');
                    }

                    if (elm.is('[data-onread]')) {
                        var fn = elm.attr('data-onread');
                        eval(fn + '(elm,file)');
                        return;
                    }

                    //Init loaders
                    var form = elm.parents('form');
                    form.find('[type=submit]:visible').each(function () {
                        var btn = $(this);
                        btn.attr('disabled', 'disabled');
                        var str = btn.html();
                        if (btn.prop('tagName') == "INPUT") {
                            str = btn.val();
                        }
                        btn.attr('data-ori-str', str);

                        var dots = 0;
                        var setLoadingStr = function () {
                            var str = "Bezig met uploaden";
                            for (var i = 0; i < dots; i++) {
                                str = str + ".";
                            }
                            if (btn.prop('tagName') == "INPUT") {
                                btn.val(str);
                            } else {
                                btn.html(str);
                            }
                            dots++;
                            if (dots > 3) {
                                dots = 0;
                            }
                        }.bind(btn);

                        setLoadingStr();
                        btn[0].loadingInterval = setInterval(setLoadingStr, 1000);
                    });

                    //Start uploading
                    var files = input[0].files;
                    var data = new FormData();
                    data.append('file', files[0]);

                    if (elm.attr('data-path') != undefined) {
                        data.append('path', elm.attr('data-path'));
                    }

                    if (elm.attr('data-max-size') != undefined) {
                        data.append('max-size', elm.attr('data-max-size'));
                    }

                    $.ajax({
                        url: '/file/upload',
                        data: data,
                        cache: false,
                        contentType: false,
                        processData: false,
                        type: 'POST',
                        success: function (data) {
                            console.log(data);
                            elm.next().val(data);
                            form.find('[type=submit]:visible').each(function () {
                                var btn = $(this);
                                clearInterval(btn[0].loadingInterval);
                                btn.removeAttr('disabled');
                                var str = btn.attr('data-ori-str');
                                if (btn.prop('tagName') == "INPUT") {
                                    btn.val(str);
                                } else {
                                    btn.html(str);
                                }
                            });
                        }
                    });
                }

            });
        });
        return this;

        function make_item_drag_and_droppable(elm, input) {
            const isAdvancedUpload = function () {
                const div = document.createElement('div');
                return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
            }();
            if (isAdvancedUpload) {
                elm
                    .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    })
                    .on('dragover dragenter', function () {
                        elm.addClass('is-dragover');
                    })
                    .on('dragleave dragend drop', function () {
                        elm.removeClass('is-dragover');
                    })
                    .on('drop', function (e) {
                        input[0].files = e.originalEvent.dataTransfer.files;
                        $(input).trigger('change');
                    });
            } else {
                elm.addClass('cannot-drop');
                console.warn('Cannot do drag & drop in this browser.');
            }
        }
    };

}(jQuery));